import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {url} from '../../../../services/url'
import axios from 'axios'

const endpoint = `${url}/service`
axios.defaults.withCredentials = true

export const getAll = createAsyncThunk('service/all', async params => {
  const response = await axios.get(endpoint, {params})
  return { allData: response.data.data, data: response.data.data, totalPages: response.data.total, params }
})

export const get = createAsyncThunk('get', async id => {
  const response = await axios.get(`${endpoint}/${id}`, { id })
  return response.data
})

export const add = createAsyncThunk('add', async (item, { dispatch, rejectWithValue }) => {
  try {
      await axios.post(endpoint, item)
      await dispatch(getAll())
  } catch (e) {
      if (!e.response) {
          throw e
      }

      return rejectWithValue(e.response.data)
  }

  return item
})

export const update = createAsyncThunk('update', async (item, {dispatch}) => {
  await axios.put(`${endpoint}/${item.id}`, item)
  await dispatch(getAll())
  return item
})

export const remove = createAsyncThunk('remove', async (item, {dispatch}) => {
  await axios.delete(`${endpoint}/${item.id}`)
  await dispatch(getAll())
  return item
})

export const getAllservice = createAsyncThunk('list/service', async () => {
  const response = await axios.get(endpoint)
  return response
}) 

export const ServiceSlice = createSlice({
  name: 'service',
  initialState: {
    data: [],
    status: 'READY',
    total: 1,
    params: {},
    selected: null,
    error: '',
    allservice: [],
    remove: {
      statusText: '',
      payload: ''
    },
    add: {
      statusText: '',
      payload: ''
    },
    update: {
      statusText: '',
      payload: ''
    }
  },
  reducers: {},
  extraReducers: builder => {
    builder
        .addCase(getAll.fulfilled, (state, action) => {
          state.data = action.payload.data
          state.params = action.payload.params
          state.total = action.payload.totalPages
          state.status = 'READY'
        })
        .addCase(getAll.pending, (state) => {
            state.loading = true
            state.status = 'PENDING'
        })
        .addCase(get.fulfilled, (state, action) => {
          state.status = 'READY'
          state.selected = action.payload
        })
        .addCase(add.fulfilled, (state, action) => {
            state.selected = action.payload
            state.status = 'SUCCESS'
            state.add.statusText = `SUCCESS ${Math.random()}`
        })
        .addCase(add.rejected, (state, action) => {
            state.status = 'ERROR'
            state.error = action.payload || 'nao deu'
            state.loading = false
        })
        .addCase(update.fulfilled, (state, action) => {
          state.selected = action.payload
            state.status = 'SUCCESS'
            state.update.statusText = `SUCCESS ${Math.random()}`
        })
        .addCase(update.rejected, (state, action) => {
          state.selected = action.error
            state.status = 'ERROR'
        })
        .addCase(remove.fulfilled, (state, action) => {
          state.remove.payload = action.payload
          state.remove.statusText = `SUCCESS ${Math.random()}`
        })
        .addCase(remove.rejected, (state, action) => {
          state.selected = action.error
            state.status = 'ERROR'
        })
        .addCase(getAllservice.fulfilled, (state, action) => {
          state.allservice = action.payload.data
          state.status = 'READY'
        })
        .addCase(getAllservice.pending, (state) => {
          state.loading = true
          state.status = 'PENDING'
        })

  }
})

export default ServiceSlice.reducer
